import { MarkerClusterer } from "@react-google-maps/api"
import React, { useRef } from "react"
import CustomCard from "components/Atoms/CustomCard"
import CenterButton from "components/Organisms/map/CenterButton"
import Map from "components/Organisms/map/Map"
import { useVendorMapList } from "graphql/vendor/vendor.hooks"
import { getPosition } from "utils/custom.utils"
import { Locations } from "utils/symbols.utils"
import VendorHeader from "./VendorHeader"
import VendorMarker from "./VendorMarker"
import { Spinner } from "@blueprintjs/core"
import AllDCLocations from "components/Templates/AllDCLocations"

const VendorMap = () => {
  const mapRef = useRef<any>()
  const { data, loading } = useVendorMapList()
  const vendors = data?.usersByGroup
  return (
    <CustomCard className="p-0">
      <VendorHeader />

      <section className="h-full relative">
        {loading && (
          <section className="absolute h-full w-full z-[1] flex justify-center items-center bg-black/10">
            <Spinner />
          </section>
        )}
        <Map
          id="vt_vendor_map"
          onLoad={map => {
            mapRef.current = map
          }}
          center={Locations.Mohadi}
          zoom={15}
        >
          <AllDCLocations />
          {vendors && (
            <MarkerClusterer minimumClusterSize={10}>
              {clusterer => {
                return (
                  <>
                    {vendors.map(v => {
                      const position = getPosition(v.address)
                      return (
                        <VendorMarker
                          clusterer={clusterer}
                          position={position}
                          key={v?.id}
                          vendor={v}
                        />
                      )
                    })}
                  </>
                )
              }}
            </MarkerClusterer>
          )}

          <CenterButton
            onClick={e => {
              // if (vendors?.length > 0) {
              const bounds = new window.google.maps.LatLngBounds()
              vendors &&
                vendors.forEach(v => {
                  const position = getPosition(v.address)
                  if (position) bounds.extend(position)
                })
              mapRef.current.fitBounds(bounds)
            }}
            className="mb-3"
          />
        </Map>
      </section>
    </CustomCard>
  )
}

export default VendorMap
